import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Container } from "reactstrap";
import { Flex, Heading, Spacer } from "@badi/badi-components";

import { getUserId } from "app/datamodel/Auth/selectors";
import { damageCoverageActivated as trackDamageCoverageActivated } from "datamodel/Conversation/tracking-events";
import { useDamageCoverage } from "modules/damage-coverage-hook";

import Actions from "../actions";
import { getActions } from "./utils";
import { HeaderRoot } from "./styled-components";

const ChatHeader = ({
  connection,
  detailsButtonVisible = false,
  onRedirect,
}) => {
  const userId = useSelector(getUserId);
  const [dmgCoverageActivated, setDmgCoverageActivated] = useState(false);
  const damageCoverageAvailable = useDamageCoverage();

  const {
    status: { statusDetail } = {},
    id: connectionId,
    actions,
  } = connection;

  const { primary, secondary } = useMemo(
    () =>
      getActions({
        actions,
        connectionId,
        dmgCoverageEnabled: damageCoverageAvailable,
      }),
    [actions, dmgCoverageActivated, damageCoverageAvailable],
  );

  const handleDmgCoverageActivated = () => {
    trackDamageCoverageActivated({ roomId: connection.room.id, userId });
    setDmgCoverageActivated(true);
  };

  return (
    <HeaderRoot>
      <Container>
        <Spacer bottom={1} lg={{ top: 0, bottom: 0 }} top={1}>
          <Flex
            alignItems="flexStart"
            direction="column"
            gutter={1}
            justify="flexStart"
            lg={{
              alignItems: "center",
              direction: "row",
              justify: "spaceBetween",
              gutter: 0,
            }}
          >
            <Flex
              alignItems="center"
              justify="spaceBetween"
              wide={detailsButtonVisible}
            >
              <Heading data-qa="conversation-header-title" level="16-Bold">
                {statusDetail}
              </Heading>
            </Flex>
            <Actions
              connection={connection}
              onDamageCoverageActivate={handleDmgCoverageActivated}
              onRedirect={onRedirect}
              primary={primary}
              reduced={detailsButtonVisible}
              secondary={secondary}
              wide={true}
            />
          </Flex>
        </Spacer>
      </Container>
    </HeaderRoot>
  );
};

ChatHeader.propTypes = {
  connection: PropTypes.shape({
    allowedActions: PropTypes.object,
    bookingReferenceId: PropTypes.string,
    bookingRequestId: PropTypes.number,
    id: PropTypes.number.isRequired,
    room: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    actions: PropTypes.shape({
      primary: PropTypes.shape({
        action: PropTypes.string,
        label: PropTypes.string,
      }),
      secondary: PropTypes.shape({
        action: PropTypes.string,
        label: PropTypes.string,
      }),
    }),
    status: PropTypes.object,
  }).isRequired,
  detailsButtonVisible: PropTypes.bool,
  onRedirect: PropTypes.func.isRequired,
};

export default ChatHeader;
